import { render, staticRenderFns } from "./BaggageExplain.vue?vue&type=template&id=0c4a4053&"
import script from "./BaggageExplain.vue?vue&type=script&lang=js&"
export * from "./BaggageExplain.vue?vue&type=script&lang=js&"
import style0 from "./BaggageExplain.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports